import React from "react";

//styling
import styles from "./ChequeForm.module.css"

// constants
import {
    ADD_CHEQUE,
    BACK, CHEQUE_PAGES, EDIT_CHEQUE, PREVIEW, SAVE_DRAFT,
} from "./constants";


import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";

import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import { TextField} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {bankAccountsSelector} from "../../../redux/selectors/settings";
import {listAllBankAccounts} from "../../../redux/actions/settings";
import withShipment from "../../../withShipment";
import SaveIcon from "@material-ui/icons/Save";
import {parseISO} from "date-fns"
import Utils from "../../Utils/Utils";
import BlockIcon from '@material-ui/icons/Block';
import UndoIcon from '@material-ui/icons/Undo';
import ClearIcon from '@material-ui/icons/Clear';
import { undoChequeVoid, voidCheque } from '../../../redux/actions/accounting';

class ChequeForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      memoo: '',
      payToName: '',
      chequeNumber: '',
      paymentDate: this.formatDate(new Date()),
      status: '',
      amount: '',
      amountWords: '',
      category: '',
      chequeId: null,
      signature: '',
      bankAccount: null,
      checkChequeFeedback: null,
      requiredList: [
        'chequeNumber',
        'paymentDate',
        'amount',
        'amountWords',
        'payToName',
        'bankAccount',
        'signature',
      ],
      showVoidOption: false,
      showUndoDeleteOptions: false,
    };
  }

  componentDidMount() {
    this.props.listAllBankAccounts();
    if (this.props.cheque?.chequeNumber) {
      const selectedBankAccount = this.props.bankAccounts.find(
        (account) =>
          `${account.name} (${account.accountNumber})` ===
          this.props.cheque.accountNumber
      );

      if (selectedBankAccount && this.props.cheque?.status === 'Printed') {
        this.handleBlur('', this.props.cheque?.chequeNumber);
      }

      const selectedCategory = this.props.categories.find(
        (category) => category.name === this.props.cheque.category
      );

      this.setState(
        {
          status: this.props.cheque?.status,
          chequeId: this.props.cheque?.chequeId,
          paymentDate: this.props.cheque.paymentDate
            ? this.props.cheque.paymentDate
            : this.formatDate(new Date()),
          memoo: this.props.cheque.memo
            ? this.props.cheque.memo
            : this.props.cheque.memoo,
          payToName: this.props.cheque.payee
            ? this.props.cheque.payee
            : this.props.cheque.payToName,
          chequeNumber: this.props.cheque.chequeNumber,
          signature: this.props.cheque.signature,
          amountWords: Utils.convertAmountToWords(
            parseFloat(
              (this.props.cheque.amount || '0').toString().replace(/,/g, '')
            )
          ),
          amount: this.props.cheque.amount,
          category: selectedCategory,
          bankAccount: selectedBankAccount
            ? selectedBankAccount
            : this.props.cheque.bankAccount,
        },
        () => {
          this.props.onFormChange(this.state);
        }
      );
    }
  }

  toggleVoidOption = () => {
    this.setState((prev) => ({ showVoidOption: !prev.showVoidOption }));
  };

  toggleUndoDeleteOptions = () => {
    this.setState((prev) => ({
      showUndoDeleteOptions: !prev.showUndoDeleteOptions,
    }));
  };

  chequeVoid = () => {
    const { chequeId } = this.state;
    this.props.voidCheque({ chequeId }, (updatedCheque) => {
      this.setState(
        {
          status: updatedCheque.status,
          showVoidOption: false,
        },
        () => {
          this.props.onFormChange(this.state);
        }
      );
    });
  };

  undoChequeVoid = () => {
    const { chequeId } = this.state;
    this.props.undoChequeVoid({ chequeId }, (updatedCheque) => {
      this.setState(
        {
          status: updatedCheque.status,
          showUndoDeleteOptions: false,
        },
        () => {
          this.props.onFormChange(this.state);
        }
      );
    });
  };

  formatDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  checkPreview = () => {
    const { requiredList, checkChequeFeedback, ...fields } = this.state;
    let hasEmpty = false;

    requiredList.forEach((field) => {
      if (!fields[field]) {
        hasEmpty = true;
      }
    });

    if (checkChequeFeedback) {
      return true;
    }

    return hasEmpty;
  };

  parseNumber = (string) => {
    return parseFloat(string?.toString().replaceAll(',', ''));
  };

  formatDollar = (amount, forceTwoDecimals) => {
    if (!amount) return;
    let value;
    if (forceTwoDecimals) {
      value = this.parseNumber(amount).toFixed(2);
    } else {
      amount = String(amount);
      if (amount.match(/.*\.\d{2}.*/)) {
        try {
          value = this.parseNumber(amount).toFixed(2);
        } catch {
          value = amount.replaceAll(',', '');
        }
      } else {
        value = amount.replaceAll(',', '');
      }
    }

    return value.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
  };

  handleChangeAmount = (e) => {
    const { name, value } = e.target;
    const newValue = this.formatDollar(e.target.value);
    this.setState({
      [name]: newValue,
    });

    const amountWords = Utils.convertAmountToWords(
      parseFloat((e.target.value || '0').toString().replace(/,/g, ''))
    );
    this.setState(
      {
        amountWords,
      },
      () => {
        this.props.onFormChange(this.state);
      }
    );
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      {
        [name]: value,
      },
      () => {
        this.props.onFormChange(this.state);
      }
    );
  };

  handleBlur = (name, value) => {
    if (value) {
      this.props.validateChequeNumber(
        { chequeNumber: value, chequeId: this.props?.cheque?.chequeId },
        this.handleChequeStatusResponse
      );
    }
  };

  handleChequeStatusResponse = (response) => {
    if (response?.data?.message) {
      this.setState({ checkChequeFeedback: response.data.message });
    } else {
      this.setState({ checkChequeFeedback: null });
    }
  };

  saveDraft = () => {
    const {
      payToName,
      amount,
      memoo,
      chequeNumber,
      paymentDate,
      category,
      bankAccount,
      chequeId,
      signature,
    } = this.state;

    const cheque = {
      amount,
      currency: bankAccount.currency,
      chequeNumber,
      paymentDate,
      payToName,
      category: category?.name,
      memo: memoo || '',
      chequeId: chequeId,
      accountNumber: `${bankAccount.name} (${bankAccount.accountNumber})`,
      signature,
      status: this.props.cheque?.status === 'Printed' ? 'Printed' : 'Draft',
    };
    this.props.saveCheque(cheque);
    this.props.setCurrentPage(CHEQUE_PAGES.TABLE, {});
  };

  onBlurHandle = (name, value) => {
    const amountFormat = isNaN(parseFloat(value))
      ? '0.00'
      : this.formatDollar(value, true);

    this.setState(
      {
        amount: amountFormat,
      },
      () => {
        this.props.onFormChange(this.state);
      }
    );
  };

  getMenuItems = () => {
    const { status, showVoidOption, showUndoDeleteOptions } = this.state;
    const isExistingCheque = !!this.props.cheque?.chequeNumber;

    const baseItems = [
      {
        title: BACK,
        icon: <KeyboardBackspaceIcon />,
        onClick: () => this.props.setCurrentPage(CHEQUE_PAGES.TABLE, {}),
      },
      {
        title: SAVE_DRAFT,
        icon: <SaveIcon />,
        onClick: () => this.saveDraft(),
        disabled: this.checkPreview(),
      },
      {
        title: PREVIEW,
        icon: <VisibilityIcon />,
        disabled: this.checkPreview(),
        onClick: () => this.props.setCurrentPage(CHEQUE_PAGES.PREVIEW, {}),
      },
    ];

    if (showUndoDeleteOptions) {
      return [
        ...baseItems,
        {
          title: <div style={{ marginLeft: '8px', marginRight: '8px' }}>|</div>,
          isNotIcon: true,
        },
        {
          icon: <ClearIcon />,
          onClick: () => this.toggleUndoDeleteOptions(),
          title: 'Cancel',
        },
        {
          icon: <UndoIcon />,
          onClick: () => this.undoChequeVoid(),
          title: 'Undo Void Cheque',
        },
      ];
    }

    if (showVoidOption) {
      return [
        ...baseItems,
        {
          title: <div style={{ marginLeft: '8px', marginRight: '8px' }}>|</div>,
          isNotIcon: true,
        },
        {
          icon: <ClearIcon />,
          onClick: () => this.toggleVoidOption(),
          title: 'Cancel',
        },
        {
          icon: <BlockIcon />,
          onClick: () => this.chequeVoid(),
          title: 'Void Cheque',
        },
      ];
    }

    if (isExistingCheque) {
      if (status === 'Void') {
        return [
          ...baseItems,
          {
            icon: <UndoIcon />,
            onClick: this.toggleUndoDeleteOptions,
            title: 'Undo Void Cheque',
          },
        ];
      } else {
        return [
          ...baseItems,
          {
            icon: <BlockIcon />,
            onClick: () => this.toggleVoidOption(),
            title: 'Void Cheque',
          },
        ];
      }
    }

    return baseItems;
  };

  render() {
    return (
      <React.Fragment>
        <ErrorFeedbackBar />
        <TopToolbar
          pageName={this.props.cheque?.chequeNumber ? EDIT_CHEQUE : ADD_CHEQUE}
          menuItems={this.getMenuItems()}
        />

        <div className={styles.rowCarrier} style={{ marginTop: '24px' }}>
          <div className={styles.rowSpec}>
            <div className="input-text-field" style={{ marginTop: '10px' }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  style={{ width: '240px' }}
                  name="paymentDate"
                  label="Payment Date"
                  value={parseISO(this.state.paymentDate)}
                  onChange={(e, value) => {
                    this.handleChange({
                      target: { name: 'paymentDate', value },
                    });
                  }}
                  format="yyyy-MM-dd"
                  variant="inline"
                  inputVariant="outlined"
                  InputLabelProps={{ shrink: true }}
                  InputAdornmentProps={{ position: 'start' }}
                  required={this.state.requiredList.includes('paymentDate')}
                />
              </MuiPickersUtilsProvider>
            </div>

            <div
              style={{
                marginLeft: '26px',
                marginTop: '10px',
                width: '100%',
              }}
            >
              <TextField
                style={{ width: '99%' }}
                variant="outlined"
                label="Pay To Order Of"
                InputLabelProps={{ shrink: true }}
                name="payToName"
                value={this.state.payToName}
                onChange={this.handleChange}
                required={this.state.requiredList.includes('payToName')}
              />
            </div>

            <div
              style={{
                marginLeft: '16px',
                marginTop: '10px',
                width: '240px',
              }}
            >
              <TextField
                style={{ width: '99%' }}
                variant="outlined"
                label="Status"
                InputLabelProps={{ shrink: true }}
                name="status"
                value={this.state.status}
                InputProps={{ readOnly: true }}
              />
            </div>
          </div>

          <div className={styles.rowSpec}>
            <div style={{ margin: '10px' }}>
              <Autocomplete
                style={{ width: '240px' }}
                options={this.props.bankAccounts}
                getOptionLabel={(option) =>
                  `${option.name} (${option.accountNumber})`
                }
                value={this.state.bankAccount}
                onChange={(e, value) => {
                  const lastChequeNumber = value?.chequeNumber
                    ? parseInt(value.chequeNumber) + 1
                    : '';
                  this.setState({
                    chequeNumber: lastChequeNumber,
                    signature: 'No signature',
                  });
                  this.handleChange({
                    target: { name: 'bankAccount', value },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="bankAccount"
                    label="Bank Account"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    required={this.state.requiredList.includes('bankAccount')}
                  />
                )}
              />
            </div>

            <TextField
              style={{ width: '220px' }}
              className={styles.formThreeInput}
              variant="outlined"
              label="Cheque Number"
              InputLabelProps={{ shrink: true }}
              name="chequeNumber"
              value={this.state.chequeNumber}
              onChange={this.handleChange}
              required={this.state.requiredList.includes('chequeNumber')}
              onBlur={(e) => this.handleBlur(e.target.name, e.target.value)}
              helperText={
                this.state.checkChequeFeedback
                  ? this.state.checkChequeFeedback
                  : null
              }
              FormHelperTextProps={{
                style: { color: 'red' },
              }}
            />

            <div
              className={styles.formThreeInput}
              style={{ margin: '10px', width: '100%' }}
            >
              <Autocomplete
                options={this.props.categories}
                getOptionLabel={(option) => option.name}
                value={this.state.category}
                onChange={(e, value) =>
                  this.handleChange({
                    target: {
                      name: 'category',
                      value: value,
                    },
                  })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required={this.state.requiredList.includes('category')}
                    name="category"
                    label="Category"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            </div>
          </div>

          <div className={styles.rowSpec}>
            <div className="input-text-field" style={{ marginTop: '10px' }}>
              <TextField
                style={{ width: '240px' }}
                required={this.state.requiredList.includes('amount')}
                variant="outlined"
                name="amount"
                label="Amount"
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                  inputProps: { style: { textAlign: 'right' } },
                }}
                value={this.formatDollar(this.state.amount)}
                onChange={(e) => this.handleChangeAmount(e)}
                onBlur={(e) => this.onBlurHandle(e.target.name, e.target.value)}
              />
            </div>

            <div
              style={{
                marginLeft: '26px',
                marginTop: '10px',
                width: '100%',
              }}
            >
              <TextField
                style={{ width: '99%' }}
                disabled={true}
                variant="outlined"
                label=""
                // className={styles.formInputsingle}
                InputLabelProps={{ shrink: true }}
                name="amountWords"
                value={this.state.amountWords}
                onChange={this.handleChange}
                required={this.state.requiredList.includes('amountWords')}
              />
            </div>
          </div>

          <div className={styles.rowSpec}>
            <TextField
              variant="outlined"
              label="Memo"
              className={styles.formInputsingle}
              InputLabelProps={{ shrink: true }}
              name="memoo"
              value={this.state.memoo}
              onChange={this.handleChange}
              required={this.state.requiredList.includes('memoo')}
            />
            {this.state.bankAccount && (
              <Autocomplete
                className={styles.formTwoInput}
                options={[
                  'No signature',
                  ...(this.state.bankAccount?.files || []),
                ]}
                getOptionLabel={(option) =>
                  option === 'No signature' ? option : option.signatoryName
                }
                value={
                  this.state.signature
                    ? this.state.bankAccount?.files?.find(
                        (file) => file.path === this.state.signature
                      ) || 'No signature'
                    : 'No signature'
                }
                onChange={(e, value) =>
                  this.handleChange({
                    target: {
                      name: 'signature',
                      value:
                        value === 'No signature' || !value
                          ? 'No signature'
                          : value.path,
                    },
                  })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required={this.state.requiredList.includes('signature')}
                    name="signature"
                    label="Signature"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
    bankAccounts: bankAccountsSelector(state),
})

const actionCreators = {
  listAllBankAccounts,
  voidCheque,
  undoChequeVoid,
};

export default withShipment({
    actionCreators,
    mapStateToProps
}, ChequeForm);

